<template>
  <div
    class="d-flex"
    :class="{
      'flex-column': stacked,
    }"
  >
    <div
      v-for="(option, i) in options"
      :key="option.text + name + i"
      class="checkbox-group"
    >
      <input
        :id="name + i"
        class="checkbox-input"
        type="checkbox"
        :name="name"
        :value="option.value"
        v-model="selectedVal"
      />
      <label
        class="checkbox-label"
        :class="{
          green: selectedVal.includes(option.value),
        }"
        :for="name + i"
        v-text="option.text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  props: {
    value: {
      required: true,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
 data: () => {
    return {
      selectedVal: [],
    }
  },
  created() {
    this.selectedVal = this.value;
  },
  watch: {
    value(newVal) {
      this.selectedVal = newVal;
    },
    selectedVal(newVal) {
      this.$emit("input", newVal);
    },
  },
}
</script>

<style lang="scss" scoped>
.green {
  color: $primaryColor !important;
}

.checkbox {
  &-group {
    display: flex;
    align-items: center;
  }
  &-input {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid $primaryColor;
    transition: all 0.2s ease;
    cursor: pointer;
    &:checked {
      padding: 2px;
      background: $primaryColor;
      position: relative;
      &::before {
        content: ' ';
        display: block;
        width: 17px;
        height: 17px;
        top: 0;
        left: 0;
        position: absolute;
        border: 2px solid white;
      }
    }
  }
  &-label {
    margin-right: 10px;
    margin-bottom: 0px !important;
  }
}
</style>
